import React from "react";
import {
  type Location,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import { Layout } from "./components/Layout";
import { privacyPolicyUrl, termsOfServiceUrl } from "./legal";
import { AccountPage } from "./pages/AccountPage";
import { ExternalLegalRedirect } from "./pages/ExternalLegalRedirect";
import { GuideDetailPage } from "./pages/GuideDetailPage";
import { GuideItemPage } from "./pages/GuideItemPage";
import { HomePage } from "./pages/HomePage";
import { ImportPage } from "./pages/ImportPage";
import { LibraryPage } from "./pages/LibraryPage";
import { LegacyDecisionRedirect } from "./pages/LegacyDecisionRedirect";
import { MarketingPage } from "./pages/MarketingPage";
import { NewDecisionPage } from "./pages/NewDecisionPage";
import { SignInPage } from "./pages/SignInPage";
import { StaticPage } from "./pages/StaticPage";
import { TokenActionPage } from "./pages/TokenActionPage";

export interface SignInLocationState {
  backgroundLocation?: Location;
  from?: string;
}

export function AppRoutes() {
  const location = useLocation();
  const state = location.state as SignInLocationState | null;
  const signInOpen = location.pathname === "/sign-in";
  const directSignInBackground: Location | undefined =
    signInOpen && !state?.backgroundLocation
      ? {
          ...location,
          pathname: "/",
          search: "",
          hash: "",
          state: null,
          key: "sign-in-background",
        }
      : undefined;
  const routeLocation =
    state?.backgroundLocation ?? directSignInBackground ?? location;

  return (
    <>
      <Routes location={routeLocation}>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="library" element={<LibraryPage />} />
          <Route path="features" element={<MarketingPage />} />
          <Route path="pricing" element={<MarketingPage />} />
          <Route path="blog" element={<MarketingPage />} />
          <Route path="guides/new" element={<NewDecisionPage />} />
          <Route
            path="guides/:accountSlug/:code"
            element={<GuideDetailPage />}
          />
          <Route
            path="guides/:accountSlug/:code/items/:itemCode"
            element={<GuideItemPage />}
          />
          <Route
            path="decisions/new"
            element={<Navigate to="/guides/new" replace />}
          />
          <Route path="decisions/:id" element={<LegacyDecisionRedirect />} />
          <Route path="account" element={<AccountPage />} />
          <Route path="import" element={<ImportPage />} />
          <Route path="about" element={<StaticPage />} />
          <Route
            path="terms"
            element={
              <ExternalLegalRedirect
                label="Terms of Service"
                url={termsOfServiceUrl}
              />
            }
          />
          <Route
            path="privacy"
            element={
              <ExternalLegalRedirect
                label="Privacy Policy"
                url={privacyPolicyUrl}
              />
            }
          />
          <Route path="cookies" element={<StaticPage />} />
          <Route
            path="subscription/confirm"
            element={<TokenActionPage action="confirm" />}
          />
          <Route
            path="unsubscribe"
            element={<TokenActionPage action="unsubscribe" />}
          />
          <Route
            path="reactivate"
            element={<TokenActionPage action="reactivate" />}
          />
          <Route
            path="*"
            element={
              <div className="page-section">
                <div className="container empty-state">
                  <h1>Page not found</h1>
                  <p>The requested page does not exist.</p>
                </div>
              </div>
            }
          />
        </Route>
      </Routes>
      {signInOpen ? <SignInPage /> : null}
    </>
  );
}
